"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9871],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ CardInnerTitle; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);





var CardInnerTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("padding:1.5rem 1rem;border-bottom:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";display:flex;align-items:center;height:64px;", props.isSpaceBetween && "justify-content: space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h3", {
                "data-test-id": props["data-test-id"],
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0 4px 0 0;font-size:16px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";"),
                children: props.title
            }),
            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, {
                linkTo: props.helpLink || undefined,
                size: "large",
                children: props.helpText
            }),
            props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";margin:0 35px 0 16px;", props.subTitleCss),
                children: props.sub
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 53156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ DescriptionList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33869);
/* harmony import */ var _CheckIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44117);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              display: flex;\n              word-break: break-all;\n              font-size: 14px;\n              line-height: 1.3;\n              color: ",
        ";\n              margin-bottom: 0.7rem;\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 1;\n                font-weight: ",
        ";\n                padding-left: ",
        ";\n                margin-right: ",
        ";\n              "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 2;\n                white-space: pre-wrap;\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var DescriptionList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dl", {
        className: props.className,
        children: Object.entries(props.list).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), _ = _param[0], v = _param[1];
            return v.isHidden !== true;
        }).map(function(param, i) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("dt", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, v.indent && "12px", v.indent && "-12px"),
                        children: [
                            k,
                            v.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_3__/* .Help */ .W, {
                                linkTo: v.helpLink,
                                children: v.help
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dd", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2()),
                        className: v.extraClassName,
                        children: v.bool ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_CheckIcon__WEBPACK_IMPORTED_MODULE_4__/* .CheckIcon */ .n, {}) : v.text
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 89277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LineClampText; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClampText = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _height = param.height, height = _height === void 0 ? 1.4 : _height, _size = param.size, size = _size === void 0 ? "14px" : _size, _stripLineBreaks = param.stripLineBreaks, stripLineBreaks = _stripLineBreaks === void 0 ? false : _stripLineBreaks, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, dataTestId = param.dataTestId;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    var text = stripLineBreaks ? children === null || children === void 0 ? void 0 : children.replace(/(\r\n|\n|\r)/gm, "") : children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        title: text !== null && text !== void 0 ? text : "",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("line-height:", height, ";font-size:", size, ";", justify ? "text-align: justify;" : "", " ", showAll || "\n          max-height: calc(".concat(size, " * ").concat(height, " * ").concat(lineNumber.desktop, ");\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          -webkit-line-clamp: ").concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            max-height: calc(").concat(size, " * ").concat(height, " * ").concat(lineNumber.mobile, ");\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        "data-test-id": dataTestId,
        children: text
    });
};


/***/ }),

/***/ 94580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ CompanyAndInvestorSummaryBg; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var CompanyAndInvestorSummaryBg = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:100%;max-width:", props.sticky ? "100%" : "1280px", ";margin-inline:auto;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{position:sticky;z-index:20;top:-200px;transition:max-width 0.16s 0s linear;}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("min-height:196px;display:flex;justify-content:space-between;flex-direction:column;position:relative;background-blend-mode:multiply;background:url(", props.backgroundImage, ") 50% 0 no-repeat,linear-gradient(\n                to bottom,", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.blueGray50 */ .O9.blueGray50, " 0,transparent 196px\n              )\n              no-repeat;background-size:auto 196px;border-radius:0;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{min-height:360px;background:url(", props.backgroundImage, ") 50% 50% no-repeat,linear-gradient(\n                to bottom,", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.blueGray50 */ .O9.blueGray50, " 100%,transparent 0\n              );background-size:cover;border-radius:", props.sticky ? "0" : "8px", ";}"),
            children: props.children
        })
    });
};


/***/ }),

/***/ 3511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ Navbar; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _header_AppBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22991);
/* harmony import */ var _header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10785);






var Navbar = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("height:56px;margin:0 auto;", !props.isUnappliedSticky && "position: sticky;", "        background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";z-index:19;border-top:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLight */ .O9.borderLight, ";border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLight */ .O9.borderLight, ";", !props.isUnappliedSticky && "".concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n          top: calc(").concat(_header_AppBarForMobile__WEBPACK_IMPORTED_MODULE_3__/* .APPBAR_HEIGHT */ .sU, " - 1px);\n        }\n        ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, " {\n          top: calc(").concat(_header_AppBar__WEBPACK_IMPORTED_MODULE_2__/* .APPBAR_HEIGHT */ .sU, " - 1px);\n        }")),
        className: props.className,
        onClick: props.onClick,
        children: props.children
    });
};


/***/ }),

/***/ 22084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ DomesticCompanyHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/modal.ts
var modal = __webpack_require__(17239);
// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanySummary.tsx + 5 modules
var CompanySummary = __webpack_require__(27544);
// EXTERNAL MODULE: ./components/pages/company/molecules/domestic/CompanyTabGroup.tsx
var CompanyTabGroup = __webpack_require__(14224);
// EXTERNAL MODULE: ./components/pages/company/molecules/TrialModal.tsx
var TrialModal = __webpack_require__(42401);
// EXTERNAL MODULE: ./components/pages/companies/components/molucule/SourcingAnnotationPanel.tsx + 8 modules
var SourcingAnnotationPanel = __webpack_require__(78650);
// EXTERNAL MODULE: ./components/common/Cover.tsx
var Cover = __webpack_require__(89543);
// EXTERNAL MODULE: ./lib/api/company.ts
var api_company = __webpack_require__(58124);
// EXTERNAL MODULE: ./lib/api/status.ts
var api_status = __webpack_require__(9926);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/api/common.ts + 3 modules
var common = __webpack_require__(6140);
;// CONCATENATED MODULE: ./lib/api/companyDownload.ts

var getCompanyDownloadInfo = function() {
    return (0,common/* callAPI */.F)("".concat(common/* basePath */.sb, "/users/company_download"));
};

// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./components/atoms/LoadableButton.tsx
var LoadableButton = __webpack_require__(84044);
// EXTERNAL MODULE: ./components/atoms/Modal.tsx
var Modal = __webpack_require__(99338);
// EXTERNAL MODULE: ./lib/tracking.ts
var tracking = __webpack_require__(56902);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyDownloadModal.tsx

















var CompanyDownloadModal = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(null), downloadInfo = ref[0], setDownloadInfo = ref[1];
    (0,react.useEffect)(function() {
        getCompanyDownloadInfo().then(function(res) {
            return setDownloadInfo(res);
        }).catch(function(err) {
            return (0,log/* printError */.O)(err);
        });
    }, []);
    if (!downloadInfo) {
        return null;
    }
    // See https://github.com/Japan-Venture-Research/penguin/pull/813
    switch(true){
        case (0,lib_user/* isTrial */.pN)(user):
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyDownloadModal_TrialModal, (0,_object_spread/* default */.Z)({}, props));
        case downloadInfo.payPerUse:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PayPerUseModal, (0,_object_spread/* default */.Z)({}, props));
        case (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && downloadInfo.allowed:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NormalModal, (0,_object_spread/* default */.Z)({}, props));
        default:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotDownloadbleModal, (0,_object_spread/* default */.Z)({}, props));
    }
};
var CompanyDownloadModal_TrialModal = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DownloadModalTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:25px;font-size:24px;"),
                children: "トライアル制限"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray70 */.O9.gray70, ";margin-top:40px;"),
                children: "こちらの機能は本契約ユーザーの方のみ利用可能となっています。"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:80px;margin-bottom:50px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: "https://s3-ap-northeast-1.amazonaws.com/entrepedia-public/samples/company_sample.pdf",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                        children: "サンプルをダウンロード"
                    })
                })
            })
        ]
    }));
};
var NotDownloadbleModal = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DownloadModalTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray70 */.O9.gray70, ";margin-top:60px;font-size:16px;line-height:1.5;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: "企業情報ダウンロードには契約プランの変更が必要です。"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            "お問い合わせ:",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "https://initial.inc/contact",
                                target: "_blank",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray70 */.O9.gray70, ";"),
                                children: "https://initial.inc/contact"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:80px;margin-bottom:50px;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    href: "https://s3-ap-northeast-1.amazonaws.com/entrepedia-public/samples/company_sample.pdf",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                        children: "サンプルをダウンロード"
                    })
                })
            })
        ]
    }));
};
var PayPerUseModal = function(props) {
    var ref = (0,react.useState)(false), agreed = ref[0], setAgreed = ref[1];
    if (agreed) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NormalModal, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DownloadModalTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyName, {
                children: props.name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:24px;color:", dist/* colors.gray70 */.O9.gray70, ";font-size:18px;text-align:center;line-height:1.5;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            "一件ダウンロードごとに",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";color:", dist/* colors.black10 */.O9.black10, ";"),
                                children: "750円（税別）"
                            }),
                            "が課金されます。"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: "料金は、契約更新時にまとめてご請求いたします。"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:30px;margin-bottom:10px;font-size:20px;color:", dist/* colors.textStrong */.O9.textStrong, ";text-decoration:none;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "info2",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:5px;")
                    }),
                    "企業情報のダウンロードについて"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.gray70 */.O9.gray70, ";line-height:1.3;white-space:pre-wrap;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:15px;li{margin-top:5px;}"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: "ファイル形式は、ExcelとPDFから選択できます。ただし、同企業のダウンロードであっても、Excelファイル、PDFファイルをそれぞれ１回ずつダウンロードした場合は２件とカウントします。"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: "企業によっては情報が少ない場合があります。ダウンロードする前に、画面上で必ず内容をご確認ください。"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: "ダウンロードしたファイル、および、掲載データのコピー、転送等は規約で禁止しています。内部資料の範囲で利用ユーザ様ご本人がご利用ください。"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                fullwidth: true,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:15px 0;"),
                onClick: function() {
                    return setAgreed(true);
                },
                children: "同意して次へ進む"
            })
        ]
    }));
};
var NormalModal = function(props) {
    var ref = (0,react.useState)(null), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(null), requestedFormat = ref1[0], setRequestedFormat = ref1[1];
    var user = (0,AuthContext/* useUser */.a)();
    (0,react.useEffect)(function() {
        setStatus(null);
    }, [
        props.shortname
    ]);
    var handleRequestDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(format) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStatus("loading");
                        setRequestedFormat(format);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api_company/* requestDownloadCompany */.qy)(props.shortname, format)
                        ];
                    case 2:
                        _state.sent();
                        (0,tracking/* trackEvent */.L9)(user, "企業個別のダウンロードリクエスト");
                        setStatus("requested");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setStatus("error");
                        (0,log/* printError */.O)(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRequestDownload(format) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadModalTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: status === "requested" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyName, {
                    children: props.name
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:30px auto 10px;"),
                    children: "ダウンロードのリクエストを送信しました"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:5px auto 10px;font-size:16px;color:", dist/* colors.blueGray50 */.O9.blueGray50, ";"),
                    children: [
                        requestedFormat === "pdf" ? "PDF" : "Excel",
                        "形式"
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:10px 40px;font-size:13px;line-height:1.75;color:", dist/* colors.textLight */.O9.textLight, ";"),
                    children: "ダウンロードの準備完了後（数分後）、メールとスピーダ上の「お知らせ」にて通知します。30分経過しても通知がない場合は、サポートデスクまでご連絡ください。"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    alt: "notification-highlight",
                    src: "/static/images/companies/download/notification-highlight.png",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;max-width:385px;margin-block-start:24px;margin-inlie:auto;")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Button */.zx, {
                    size: "small",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;"),
                    onClick: props.onClose,
                    children: "閉じる"
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyName, {
                    children: props.name
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:24px auto 0;max-width:527px;font-size:14px;line-height:1.5;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";"),
                    "data-test-id": "download-modal-description",
                    children: [
                        "ご希望のファイルの形式の［ダウンロード］をクリックすると、ダウンロードの準備が始まります。",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                        "なお、ダウンロードファイルの生成に、数分かかります。"
                    ]
                }),
                status === "error" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;color:", dist/* colors.red50 */.O9.red50, ";"),
                    children: "企業データダウンロード中にエラーが発生しました。"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:baseline;grid-column-gap:32px;margin:40px 0 10px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadableButton/* LoadableButton */.L, {
                            size: "small",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:200px;"),
                            onClick: function() {
                                return handleRequestDownload("pdf");
                            },
                            isLoading: status === "loading" && requestedFormat === "pdf",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "download",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:4px;")
                                }),
                                "PDFをダウンロード"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadableButton/* LoadableButton */.L, {
                            size: "small",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:200px;"),
                            onClick: function() {
                                return handleRequestDownload("xlsx");
                            },
                            isLoading: status === "loading" && requestedFormat === "xlsx",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "download",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:4px;")
                                }),
                                "Excelをダウンロード"
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
var DownloadModalTemplate = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Modal */.u_, {
        isHidden: !props.isOpen,
        onClose: props.onClose,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:640px;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";display:flex;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;font-size:14px;line-height:1.5;letter-spacing:0.02em;"),
                        children: "企業情報のダウンロード"
                    })
                }),
                props.children
            ]
        })
    });
};
var CompanyName = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:18px;line-height:1.5;letter-spacing:0.02em;margin:2px auto 0;"),
        children: props.children
    });
};

// EXTERNAL MODULE: ./components/pages/companies/components/SourcingAnnotationCandidateEditModal.tsx + 1 modules
var SourcingAnnotationCandidateEditModal = __webpack_require__(73153);
// EXTERNAL MODULE: ./lib/company.ts
var lib_company = __webpack_require__(10133);
;// CONCATENATED MODULE: ./components/pages/company/DomesticCompanyHeader.tsx


















var DomesticCompanyHeader = function(param) {
    var company = param.company, status = param.status, memo = param.memo, contactPerson = param.contactPerson, activeTab = param.activeTab, user = param.user;
    var ref = (0,react.useState)(false), isStatusPanelVisible = ref[0], setIsStatusPanelVisible = ref[1];
    var ref1 = (0,react.useState)(true), isHiddenMyLabelCandidateModal = ref1[0], setIsHiddenMyLabelCandidateModal = ref1[1];
    var ref2 = (0,react.useState)(true), isHiddenSourcingRouteCandidateModal = ref2[0], setIsHiddenSourcingRouteCandidateModal = ref2[1];
    var ref3 = (0,react.useState)([]), statuses = ref3[0], setStatuses = ref3[1];
    var ref4 = (0,react.useState)({
        users: []
    }), contactPersons = ref4[0], setContactPersons = ref4[1];
    var ref5 = (0,react.useState)([]), myLabels = ref5[0], setMyLabels = ref5[1];
    var ref6 = (0,react.useState)([]), sourcingRoutes = ref6[0], setSourcingRoutes = ref6[1];
    var ref7 = (0,react.useState)(status), selectedStatus = ref7[0], setSelectedStatus = ref7[1];
    var ref8 = (0,react.useState)(contactPerson), selectedContactPerson = ref8[0], setSelectedContactPerson = ref8[1];
    // 表示中の企業に依存しない情報の取得
    (0,react.useEffect)(function() {
        var run = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, statuses, contactPersons, candidates;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    (0,api_company/* getCompanyStatuses */.w2)(),
                                    (0,api_company/* getContactPersons */.Kd)(),
                                    (0,api_status/* getSourcingAnnotationCandidates */.Wo)()
                                ])
                            ];
                        case 1:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                3
                            ]), statuses = ref[0], contactPersons = ref[1], candidates = ref[2];
                            setStatuses(statuses);
                            setContactPersons(contactPersons);
                            if (candidates) {
                                setMyLabels(candidates.myLabels);
                                setSourcingRoutes(candidates.sourcingRoutes);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function run() {
                return _ref.apply(this, arguments);
            };
        }();
        run();
    }, []);
    // NOTE: 別の個別企業ページに直接遷移したときに
    // ステータスと担当者の状態を初期化する
    // これがないと、遷移前の企業のステータスや担当者が表示されてしまう
    // refs: https://uzabase.slack.com/archives/C9JE6SZNK/p1701418971486939
    (0,react.useEffect)(function() {
        setSelectedStatus(status);
        setSelectedContactPerson(contactPerson);
    }, [
        company.shortname
    ]);
    var ref9 = (0,modal/* useModal */.d)({
        key: "trial"
    }), isTrialModalOpen = ref9.isOpen, showTrialModal = ref9.show, hideTrialModal = ref9.hide;
    var ref10 = (0,modal/* useModal */.d)({
        key: "download"
    }), isDownloadModalOpen = ref10.isOpen, showDownloadModal = ref10.show, hideDownloadModal = ref10.hide;
    var refreshSourcingAnnotationCandidates = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var candidates;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* getSourcingAnnotationCandidates */.Wo)()
                        ];
                    case 1:
                        candidates = _state.sent();
                        if (candidates) {
                            setMyLabels(candidates.myLabels);
                            setSourcingRoutes(candidates.sourcingRoutes);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function refreshSourcingAnnotationCandidates() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSourcingRouteModalClose = function() {
        setIsHiddenSourcingRouteCandidateModal(true);
    };
    var handleSelectSourcingRoute = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, sourcingRouteId, _sourcingRouteName, _user) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* registerCompanySourcingRoute */.sw)(companyId, sourcingRouteId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectSourcingRoute(companyId, sourcingRouteId, _sourcingRouteName, _user) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeselectSourcingRoute = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(companyId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* deleteCompanySourcingRoute */.hq)(companyId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeselectSourcingRoute(companyId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRequestEditSourcingRouteModal = function() {
        setIsHiddenSourcingRouteCandidateModal(false);
    };
    var handleCreateSourcingRoute = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* postSourcingRoute */.us)(name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateSourcingRoute(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateSourcingRoute = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, name) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* putSourcingRoute */.PQ)(id, name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateSourcingRoute(id, name) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteSourcingRoute = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* deleteSourcingRoute */.BH)(id)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteSourcingRoute(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRequestEditMyLabelModal = function() {
        setIsHiddenMyLabelCandidateModal(false);
    };
    var handleMyLabelModalClose = function() {
        setIsHiddenMyLabelCandidateModal(true);
    };
    var handleCreateMyLabel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* postMyLabel */.i1)(name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateMyLabel(name) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateMyLabel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, name) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* putMyLabel */.XC)(id, name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateMyLabel(id, name) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteMyLabel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_status/* deleteMyLabel */.oe)(id)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            refreshSourcingAnnotationCandidates()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteMyLabel(id) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isStatusPanelVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* Cover */.Y, {
                zIndex: 21,
                handleClick: function() {
                    return setIsStatusPanelVisible(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                "data-test-id": "domestic-company-header",
                "data-testid": "domestic-company-header",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySummary/* CompanySummary */.s2, {
                        company: company,
                        showModal: showTrialModal,
                        setIsStatusPanelVisible: setIsStatusPanelVisible,
                        companyStatus: status,
                        contactPerson: contactPerson,
                        statuses: statuses,
                        users: contactPersons,
                        companyMemo: memo,
                        selectedStatus: selectedStatus,
                        setSelectedStatus: setSelectedStatus,
                        selectedContactPerson: selectedContactPerson,
                        setSelectedContactPerson: setSelectedContactPerson
                    }),
                    !((0,lib_user/* isGuest */.nJ)(user) && (0,lib_company/* isResearchDone */.UX)(company) && !(0,lib_company/* isExited */.EC)(company)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyTabGroup/* CompanyTabGroup */.l, {
                        data: company,
                        activeTab: activeTab,
                        showDownloadModal: showDownloadModal,
                        showTrialModal: showTrialModal
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationPanel/* SourcingAnnotationPanel */.h, {
                isOpen: isStatusPanelVisible,
                myLabels: myLabels,
                sourcingRoutes: sourcingRoutes,
                companyShortname: company.shortname,
                onSelectStatus: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, status) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* registerCompanyStatus */.h$)(companyId, status.id)
                                    ];
                                case 1:
                                    _state.sent();
                                    setSelectedStatus(status);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId, status) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectStatusBlank: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* deleteCompanyStatus */.lZ)(companyId)
                                    ];
                                case 1:
                                    _state.sent();
                                    setSelectedStatus(null);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectContactPerson: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(contactPerson) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* registerCompanyContactPerson */.ds)(contactPerson.companyId, contactPerson.userId, function() {})
                                    ];
                                case 1:
                                    _state.sent();
                                    setSelectedContactPerson(contactPerson);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(contactPerson) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectContactPersonBlank: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* deleteCompanyContactPerson */._v)(companyId, function() {})
                                    ];
                                case 1:
                                    _state.sent();
                                    setSelectedContactPerson(null);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectMyLabel: function(myLabelId, companyId) {
                    (0,api_company/* addMyLabel */.B1)(companyId, myLabelId, user);
                },
                onDeselectMyLabel: function(myLabelId, companyId) {
                    (0,api_company/* removeMyLabel */.xe)(companyId, myLabelId, user);
                },
                onRequestEditMyLabelModal: handleRequestEditMyLabelModal,
                onSelectFirstInterviewDate: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, firstInterviewDate) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* registerFirstInterviewDate */.jI)(companyId, firstInterviewDate)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId, firstInterviewDate) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectFirstInterviewDateBlank: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* deleteFirstInterviewDate */.nj)(companyId)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onSelectSourcingRoute: handleSelectSourcingRoute,
                onDeselectSourcingRoute: handleDeselectSourcingRoute,
                onRequestEditSourcingRouteModal: handleRequestEditSourcingRouteModal,
                onUpdateMemo: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, memo) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,api_company/* saveCompanyMemo */.zt)(companyId, memo, function() {})
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(companyId, memo) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                closePanel: function() {
                    setIsStatusPanelVisible(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrialModal/* TrialModal */.B, {
                isOpen: isTrialModalOpen,
                hideModal: hideTrialModal
            }),
            (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyDownloadModal, {
                shortname: company.shortname,
                name: company.name,
                isOpen: isDownloadModalOpen,
                onClose: hideDownloadModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationCandidateEditModal/* SourcingAnnotationCandidateEditModal */.$, {
                isHidden: isHiddenSourcingRouteCandidateModal,
                modalId: "sourcing-route",
                modalName: "ソーシングルート",
                onCreate: handleCreateSourcingRoute,
                onUpdate: handleUpdateSourcingRoute,
                onDelete: handleDeleteSourcingRoute,
                onClose: handleSourcingRouteModalClose,
                children: sourcingRoutes
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SourcingAnnotationCandidateEditModal/* SourcingAnnotationCandidateEditModal */.$, {
                isHidden: isHiddenMyLabelCandidateModal,
                modalId: "my-label",
                modalName: "マイラベル",
                onCreate: handleCreateMyLabel,
                onUpdate: handleUpdateMyLabel,
                onDelete: handleDeleteMyLabel,
                onClose: handleMyLabelModalClose,
                children: myLabels
            })
        ]
    });
};


/***/ }),

/***/ 46923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var _lib_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10133);
/* harmony import */ var _atoms_LineClampText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89277);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20932);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15598);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14380);









var Description = function(param) {
    var company = param.company;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isInitialized = ref[0], setIsInitailized = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isShowAll = ref1[0], setIsShowAll = ref1[1];
    var textEl = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setIsShowAll(false);
    }, [
        company
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!textEl || !textEl.current) {
            return;
        }
        setIsInitailized(true);
        if (!isOverflown(textEl.current)) {
            setIsShowAll(true);
        }
    }, [
        textEl
    ]);
    var handleClickReadMore = function(e) {
        e.preventDefault();
        setIsShowAll(true);
    };
    var showReadMore = isInitialized && !isShowAll;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
        className: "description",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("margin-top:20px;"),
        "data-test-id": "description",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .font.weight.bold */ .LZ.weight.bold, ";font-size:13px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.black10 */ .O9.black10, ";"),
                        children: "事業内容"
                    }),
                    (0,_lib_company__WEBPACK_IMPORTED_MODULE_1__/* .isDomesticCompanyData */ .At)(company) && (0,_lib_company__WEBPACK_IMPORTED_MODULE_1__/* .isResearchContinue */ .hD)(company) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("font-size:12px;padding-left:10px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.textLight */ .O9.textLight, ";"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                                className: _lib_wovn__WEBPACK_IMPORTED_MODULE_8__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
                                "data-test-id": "updated-at",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_5__/* .FormattedDate */ .J, {
                                    children: company.descriptionUpdatedAt
                                })
                            }),
                            " 更新"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("display:flex;align-items:flex-end;grid-gap:12px;padding-bottom:18px;margin-top:5px;white-space:pre-wrap;line-height:1.5;font-size:14px;line-height:1.4;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_2__/* .LineClampText */ .R, {
                        justify: true,
                        lineNumber: 2,
                        showAll: isShowAll,
                        lineClampRef: textEl,
                        className: "text",
                        children: company.description
                    }),
                    showReadMore && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                        className: "view-all",
                        onClick: handleClickReadMore,
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("flex-shrink:0;font-size:14px;"),
                        children: "すべて見る"
                    })
                ]
            })
        ]
    });
};
var isOverflown = function(elm) {
    return elm.scrollHeight > elm.clientHeight || elm.scrollWidth > elm.clientWidth;
};


/***/ }),

/***/ 42401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TrialModal; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99338);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48261);








var TrialModal = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_atoms_Modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        isHidden: !props.isOpen,
        onClose: props.hideModal,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("max-width:640px;.modal-content{padding:0;}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("img", {
                alt: "trial modal image",
                src: "/static/images/companies/guest/trial.png",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("border-radius:5px 5px 0 0;width:100%;")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("display:flex;align-items:center;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{padding:16px 16px 36px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{padding:16px 40px 32px;}"),
                "data-testid": "trial-modal",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .font.weight.normal */ .LZ.weight.normal, ";line-height:175%;letter-spacing:0.02em;color:", plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .colors.text */ .O9.text, ";", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{font-size:14px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{font-size:16px;}"),
                        children: "有料契約限定のコンテンツです。無料トライアルに申し込むと、すべての機能/コンテンツをご覧になれます（一部対象外の機能あり）。"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_5__/* .trialRequestUrl */ .d1,
                        passHref: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                            target: "_blank",
                            className: "trial-link",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.untilMedium, "{margin-top:16px;width:310px;}", plume_ui__WEBPACK_IMPORTED_MODULE_3__.mq.large, "{margin-top:26px;width:320px;}"),
                                children: "無料トライアルに申し込む"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                        decoration: "none",
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_5__/* .loginPath */ .Qv,
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("margin-top:20px;font-size:14px;"),
                        children: "契約済みの方はログインしてください"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 27544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s2": function() { return /* binding */ CompanySummary; },
  "hK": function() { return /* binding */ DateNote; },
  "CB": function() { return /* binding */ EyecatchBg; },
  "yF": function() { return /* binding */ SummaryLabel; },
  "Kr": function() { return /* binding */ SummaryLabelAnnotation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/company.ts
var company = __webpack_require__(10133);
// EXTERNAL MODULE: ./lib/number.ts
var number = __webpack_require__(41181);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
// EXTERNAL MODULE: ./components/common/Help.tsx
var Help = __webpack_require__(33869);
// EXTERNAL MODULE: ./lib/api/company.ts
var api_company = __webpack_require__(58124);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./components/common/FollowButton.tsx
var FollowButton = __webpack_require__(56162);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanyFollowButton.tsx






var CompanyFollowButton = function(props) {
    var ref = (0,react.useState)(false), isFollowing = ref[0], setIsFollowing = ref[1];
    (0,react.useEffect)(function() {
        (0,api_company/* getCompanyFollowing */.ix)(props.shortname).then(function(res) {
            setIsFollowing(res.following);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    }, [
        props.shortname
    ]);
    var follow = function(shortname) {
        (0,api_company/* followCompany */.s9)(shortname).then(function(res) {
            setIsFollowing(res.following);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    };
    var unfollow = function(shortname) {
        (0,api_company/* unfollowCompany */.E1)(shortname).then(function(res) {
            setIsFollowing(res.following);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    };
    return props.isEnterprise ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton/* FollowButton */.e, {
        isFollowed: isFollowing,
        onFollow: function() {
            return follow(props.shortname);
        },
        onUnfollow: function() {
            return unfollow(props.shortname);
        },
        className: props.className,
        theme: "dark-bg"
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
        className: "follow-button-tooltip",
        label: "有料契約限定の機能です",
        place: "bottom",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton/* FollowButton */.e, {
            isFollowed: false,
            onFollow: function() {
                return props.showModal();
            },
            onUnfollow: function() {
                return false;
            },
            className: props.className,
            theme: "dark-bg"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./lib/tracking.ts
var tracking = __webpack_require__(56902);
// EXTERNAL MODULE: ./hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(24211);
;// CONCATENATED MODULE: ./components/pages/company/molecules/ContactPersonIcon.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  line-height: 125%;\n                  letter-spacing: 0.02em;\n                  gap: 8px;\n                  font-size: 14px;\n                  color: ",
        ";\n                  cursor: pointer;\n                  padding: 7px 16px 7px 36px;\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      position: absolute;\n                      font-size: 12px;\n                      left: 12px;\n                      z-index: 1;\n                      color: ",
        ";\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    color: ",
        ";\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var ContactPersonIcon = function(param) {
    var shortname = param.shortname, selectedContactPerson = param.selectedContactPerson, setSelectedContactPerson = param.setSelectedContactPerson, users = param.users;
    var ref;
    var ref1 = (0,react.useState)(false), usersOpening = ref1[0], setUsersOpening = ref1[1];
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref2 = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        ref2
    ], function() {
        return setUsersOpening(false);
    });
    var handleChangeCompanyContactPerson = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(user) {
            var preUser;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        preUser = JSON.parse(JSON.stringify(selectedContactPerson));
                        setSelectedContactPerson({
                            userId: user.id,
                            companyId: shortname,
                            imageUrl: user.imageUrl,
                            firstName: user.firstName,
                            lastName: user.lastName
                        });
                        return [
                            4,
                            (0,api_company/* registerCompanyContactPerson */.ds)(shortname, user.id, function() {
                                return setSelectedContactPerson(preUser);
                            })
                        ];
                    case 1:
                        _state.sent();
                        setUsersOpening(false);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* CONTACT_PERSON_SETTING_ON_COMPANY_PAGE */.LJ);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_CONTACT_PERSON_SETTING */.FE);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeCompanyContactPerson(user) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteCompanyContactPerson = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var preUser;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        preUser = JSON.parse(JSON.stringify(selectedContactPerson));
                        setSelectedContactPerson(null);
                        return [
                            4,
                            (0,api_company/* deleteCompanyContactPerson */._v)(shortname, function() {
                                return setSelectedContactPerson(preUser);
                            })
                        ];
                    case 1:
                        _state.sent();
                        setUsersOpening(false);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* CONTACT_PERSON_SETTING_ON_COMPANY_PAGE */.LJ);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_CONTACT_PERSON_SETTING */.FE);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteCompanyContactPerson() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "contact-person",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:64px;flex-shrink:0;display:flex;flex-direction:column;"),
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Tooltip */.u, {
                className: "contact-person-icon-tooltip",
                label: selectedContactPerson ? "".concat(selectedContactPerson.lastName, " ").concat(selectedContactPerson.firstName) : "担当者を選択",
                place: "top",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:50%;border:", selectedContactPerson ? "none" : "1px dashed ".concat(dist/* colors.white00 */.O9.white00), ";margin:auto;position:relative;background-color:", selectedContactPerson ? selectedContactPerson.imageUrl ? "transparent" : dist/* colors.blue50 */.O9.blue50 : "transparent", ";&:hover{cursor:pointer;&:before{background-color:rgba(0,0,0,0.08);position:absolute;border-radius:50%;top:0;right:0;bottom:0;left:0;content:' ';}}"),
                        onClick: function() {
                            return setUsersOpening(function(pre) {
                                return !pre;
                            });
                        },
                        children: selectedContactPerson ? selectedContactPerson.imageUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:40px;height:40px;object-fit:cover;border-radius:50%;max-width:unset;"),
                            src: selectedContactPerson.imageUrl
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;z-index:1;"),
                            className: "default",
                            children: (ref = selectedContactPerson.lastName) === null || ref === void 0 ? void 0 : ref.slice(0, 2)
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "person",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:24px;color:white;z-index:1;")
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:4px;font-size:11px;line-height:1.25;text-align:center;"),
                        children: "担当者"
                    })
                ]
            }),
            usersOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
                className: "users",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:216px;max-height:345px;margin-top:7.5px;background:", dist/* colors.white00 */.O9.white00, ";border-radius:2px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:5px 0;position:absolute;list-style:none;white-space:nowrap;transition:0.2s;z-index:50;overflow:auto;li:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        handleDeleteCompanyContactPerson()
                                    ];
                                });
                            }),
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;"),
                            children: [
                                !selectedContactPerson && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "check1",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;font-size:12px;left:12px;z-index:1;color:", dist/* colors.black30 */.O9.black30, ";")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";padding-left:8px;"),
                                    children: "（空白）"
                                })
                            ]
                        }),
                        users.users.map(function(user) {
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), dist/* colors.black30 */.O9.black30),
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            handleChangeCompanyContactPerson(user)
                                        ];
                                    });
                                }),
                                children: [
                                    (selectedContactPerson === null || selectedContactPerson === void 0 ? void 0 : selectedContactPerson.userId) === user.id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "check1",
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), dist/* colors.black30 */.O9.black30)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject2(), dist/* colors.black30 */.O9.black30),
                                        className: "user-name",
                                        children: "".concat(user.lastName, " ").concat(user.firstName)
                                    })
                                ]
                            }, user.id);
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/company/molecules/Description.tsx
var Description = __webpack_require__(46923);
;// CONCATENATED MODULE: ./components/pages/company/molecules/StatusIcon.tsx



function StatusIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  line-height: 125%;\n                  letter-spacing: 0.02em;\n                  gap: 8px;\n                  font-size: 14px;\n                  color: ",
        ";\n                  cursor: pointer;\n                  padding: 7px 16px 7px 36px;\n                "
    ]);
    StatusIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StatusIcon_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      position: absolute;\n                      font-size: 12px;\n                      left: 12px;\n                      z-index: 1;\n                      color: ",
        ";\n                    "
    ]);
    StatusIcon_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StatusIcon_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      width: 8px;\n                      height: 8px;\n                      border-radius: 50%;\n                      background-color: ",
        ";\n                    "
    ]);
    StatusIcon_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    font-size: 14px;\n                    color: ",
        ";\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var StatusIcon = function(param) {
    var shortname = param.shortname, statuses = param.statuses, selectedStatus = param.selectedStatus, setSelectedStatus = param.setSelectedStatus;
    var currentUser = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(false), statusListOpening = ref[0], setStatusListOpening = ref[1];
    var statusSettingLink = function() {
        window.open(url/* statusSettingPath */.Uk, "_blank");
    };
    var ref1 = (0,react.useRef)(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        ref1
    ], function() {
        return setStatusListOpening(false);
    });
    var handleChangeCompanyStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(status) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_company/* registerCompanyStatus */.h$)(shortname, status.id)
                        ];
                    case 1:
                        _state.sent();
                        setSelectedStatus(status);
                        setStatusListOpening(false);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* STATUS_SETTING_ON_CAMPANY_PAGE */.aH);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_STATUS_SETTING */.nW);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeCompanyStatus(status) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteCompanyStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_company/* deleteCompanyStatus */.lZ)(shortname)
                        ];
                    case 1:
                        _state.sent();
                        setSelectedStatus(null);
                        setStatusListOpening(false);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* STATUS_SETTING_ON_CAMPANY_PAGE */.aH);
                        (0,tracking/* trackEvent */.L9)(currentUser, tracking/* SUM_OF_STATUS_SETTING */.nW);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteCompanyStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "status",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:64px;flex-shrink:0;display:flex;flex-direction:column;"),
        onClick: function() {
            return setStatusListOpening(!statusListOpening);
        },
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Tooltip */.u, {
                className: "status-icon-tooltip",
                label: selectedStatus ? selectedStatus.name : "ステータスを選択",
                place: "top",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "status-color",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:50%;position:relative;border:", selectedStatus ? "1px solid ".concat(selectedStatus.color) : "1px dashed ".concat(dist/* colors.white00 */.O9.white00), ";margin:auto;background-color:", selectedStatus ? selectedStatus.color : "transparent", ";&:hover{cursor:pointer;&:before{background-color:rgba(0,0,0,0.08);position:absolute;border-radius:50%;top:0;right:0;bottom:0;left:0;content:' ';}}"),
                        children: selectedStatus ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "status-symbol",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("z-index:1;"),
                            children: selectedStatus.symbol
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "check1",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;z-index:1;")
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:4px;font-size:11px;line-height:1.25;text-align:center;"),
                        children: "ステータス"
                    })
                ]
            }),
            statusListOpening && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
                className: "statuses",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:216px;max-height:345px;margin-top:7.5px;background:", dist/* colors.white00 */.O9.white00, ";border-radius:2px;box-shadow:0px 0px 10px rgba(0,0,0,0.1);padding:5px 0;position:absolute;list-style:none;white-space:nowrap;transition:0.2s;z-index:50;overflow:auto;li:hover{background-color:", dist/* colors.gray40 */.O9.gray40, ";}"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        handleDeleteCompanyStatus()
                                    ];
                                });
                            }),
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;"),
                            children: [
                                selectedStatus === null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "check1",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;font-size:12px;left:12px;z-index:1;color:", dist/* colors.black30 */.O9.black30, ";")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";padding-left:8px;"),
                                    children: "（空白）"
                                })
                            ]
                        }),
                        statuses.map(function(status) {
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            handleChangeCompanyStatus(status)
                                        ];
                                    });
                                }),
                                css: (0,emotion_react_browser_esm/* css */.iv)(StatusIcon_templateObject(), dist/* colors.black30 */.O9.black30),
                                children: [
                                    status.id === (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                        name: "check1",
                                        css: (0,emotion_react_browser_esm/* css */.iv)(StatusIcon_templateObject1(), dist/* colors.black30 */.O9.black30)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: (0,emotion_react_browser_esm/* css */.iv)(StatusIcon_templateObject2(), status.color)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), dist/* colors.black30 */.O9.black30),
                                        className: "status-name",
                                        children: status.name
                                    })
                                ]
                            }, status.id);
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:4px 0;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:row;align-items:center;line-height:125%;letter-spacing:0.02em;gap:8px;font-size:14px;color:", dist/* colors.black30 */.O9.black30, ";cursor:pointer;padding:7px 16px 7px 36px;position:relative;"),
                            onClick: statusSettingLink,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    name: "pen-fill",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;left:12px;z-index:1;color:", dist/* colors.gray60 */.O9.gray60, ";")
                                }),
                                "ステータス項目を編集"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/company/SubCommandMenu.tsx








var SubCommandMenu = function(props) {
    var ref = (0,react.useState)(false), subCommandMenuOpened = ref[0], setSubCommandMenuOpened = ref[1];
    var toggleCommandMenuOpened = function() {
        setSubCommandMenuOpened(!subCommandMenuOpened);
    };
    var refMoreButton = react.useRef(null);
    var refMenus = react.useRef(null);
    (0,useOnClickOutside/* useOnClickOutside */.t)([
        refMoreButton,
        refMenus
    ], function() {
        return setSubCommandMenuOpened(false);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "more-button",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
                className: "more-icon-tooltip",
                label: "もっと見る",
                place: "top",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    ref: refMoreButton,
                    onClick: toggleCommandMenuOpened,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:1px solid ", dist/* colors.white00 */.O9.white00, ";border-radius:2px;height:28px;width:28px;display:flex;justify-content:center;align-items:center;color:inherit;background:", subCommandMenuOpened ? "rgba(0, 0, 0, 0.03)" : "rgba(0,0,0,0)", ";:hover{background:rgba(0,0,0,0.03);cursor:pointer;}"),
                    "data-test-id": "more",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                        name: "more-horizotal"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                ref: refMenus,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:0;display:", subCommandMenuOpened ? "block" : "none", ";position:absolute;right:0;top:calc(100% + 12px);background:", dist/* colors.white00 */.O9.white00, ";padding-block:8px;border-radius:2px;box-shadow:0px 3px 4px -2px rgba(0,0,0,0.1),0px 1px 12px -1px rgba(0,0,0,0.1);"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubCommandMenuItem, {
                        href: (0,url/* addingSmartroundProspectManagementStartupListUrl */.zx)({
                            name: props.company.name,
                            shortname: props.company.shortname,
                            corporateNumber: props.company.corporateNumber
                        }),
                        dataTestId: "smartround",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-bottom:1px solid ", dist/* colors.border */.O9.border, ";"),
                        children: "smartroundの案件リストに追加"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubCommandMenuItem, {
                        href: (0,url/* twitterShareUrl */.nv)((0,url/* companyUrl */.c2)(props.company), props.company.name),
                        dataTestId: "twitter",
                        suppressHydrationWarning: true,
                        children: "Xでシェア"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubCommandMenuItem, {
                        href: (0,url/* facebookShareUrl */.mk)((0,url/* companyUrl */.c2)(props.company)),
                        dataTestId: "facebook",
                        suppressHydrationWarning: true,
                        children: "Facebookでシェア"
                    })
                ]
            })
        ]
    });
};
var SubCommandMenuItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        className: props.className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: props.href,
            "data-test-id": props.dataTestId,
            target: "_blank",
            suppressHydrationWarning: props.suppressHydrationWarning,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;min-height:40px;padding-block:8px;padding-inline:16px;font-size:14px;color:", dist/* colors.text */.O9.text, ";line-height:1;letter-spacing:0.02em;white-space:nowrap;:hover{background:rgba(0,0,0,0.03);}"),
            children: props.children
        })
    });
};

// EXTERNAL MODULE: ./components/atoms/Overlay.tsx
var Overlay = __webpack_require__(41691);
;// CONCATENATED MODULE: ./components/pages/company/molecules/MemoIcon.tsx






var MemoIcon = function(param) {
    var companyMemo = param.companyMemo, setIsStatusPanelVisible = param.setIsStatusPanelVisible;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-width:64px;flex-shrink:0;display:flex;justify-content:center;"),
        "data-test-id": "status-panel-button",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Tooltip */.u, {
            className: "status-panel-icon-tooltip",
            label: "ステータスパネルを開く",
            place: "top",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay/* Overlay */.a, {
                        show: (0,company/* checkMemoUpdatedWithinOneWeek */.m8)(companyMemo),
                        overlay: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-radius:50%;background-color:", dist/* colors.red60 */.O9.red60, ";width:6px;height:6px;display:flex;justify-content:center;"),
                            className: "within-one-week"
                        }),
                        top: 4,
                        right: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            onClick: function() {
                                return setIsStatusPanelVisible(true);
                            },
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:50%;position:relative;border:", companyMemo ? "1px solid ".concat(dist/* colors.blue50 */.O9.blue50) : "1px dashed ".concat(dist/* colors.white00 */.O9.white00), ";background-color:", companyMemo ? dist/* colors.blue50 */.O9.blue50 : "transparent", ";&:hover{cursor:pointer;&:before{background-color:rgba(0,0,0,0.08);position:absolute;border-radius:50%;top:0;right:0;bottom:0;left:0;content:' ';}}"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                name: "side-panel",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;z-index:1;")
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:4px;font-size:11px;line-height:1.25;text-align:center;"),
                    children: [
                        "ステータス",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                        "パネル"
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./lib/wovn.ts
var wovn = __webpack_require__(15598);
// EXTERNAL MODULE: ./lib/sticky.ts
var sticky = __webpack_require__(76830);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
// EXTERNAL MODULE: ./components/common/CompanyAndInvestorSummaryBg.tsx
var CompanyAndInvestorSummaryBg = __webpack_require__(94580);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/pages/company/molecules/domestic/CompanySummary.tsx

function CompanySummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    margin-right: 8px;\n                  "
    ]);
    CompanySummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanySummary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      font-size: 13px;\n                      color: ",
        ";\n                      transition: 0.3s;\n                      &:hover {\n                        color: ",
        ";\n                        text-decoration: underline;\n                      }\n                    "
    ]);
    CompanySummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























var CompanySummary = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var ref = (0,react.useState)(false), isCompanySummaryStickyPosition = ref[0], setIsCompanySummaryStickyPosition = ref[1];
    react.useEffect(function() {
        window.addEventListener("scroll", function() {
            setIsCompanySummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                setIsCompanySummaryStickyPosition(sticky/* checkSummaryStickyPosition */.t);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline;"),
        "data-test-id": "summary",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EyecatchBg, {
                tags: props.company.tags,
                sticky: isCompanySummaryStickyPosition,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{margin-block-start:24px;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;z-index:1;display:flex;justify-content:space-between;width:100%;padding-block-start:12px;padding-inline:24px;", dist.mq.large, "{position:static;padding-inline:16px 38px;}"),
                        children: [
                            (0,lib_user/* isModerator */.vJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditLogoLink, {
                                    shortname: props.company.shortname
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;color:", dist/* colors.white00 */.O9.white00, ";font-size:12px;line-height:1.25;letter-spacing:0.02em;"),
                                children: ((0,company/* isResearchDone */.UX)(props.company) || (0,company/* isResearchUnvalued */.a5)(props.company)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        "最終更新日:",
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                children: props.company.lastUpdatedAt
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:flex-end;width:100%;max-width:", isCompanySummaryStickyPosition && "1120px", ";margin-block-start:auto;margin-inline:auto;padding-inline:24px;color:", dist/* colors.textInvert */.O9.textInvert, ";", dist.mq.large, "{padding-inline:", isCompanySummaryStickyPosition ? "0" : "20px", ";}", dist.mq.extraLarge, "{padding-inline:", isCompanySummaryStickyPosition ? "0" : "50px", ";}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:", isCompanySummaryStickyPosition ? "center" : "end", ";justify-content:space-between;column-gap:24px;width:100%;", dist.mq.large, "{min-height:", isCompanySummaryStickyPosition ? "96px" : "80px", ";}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:start;flex-direction:column;column-gap:", isCompanySummaryStickyPosition ? "16px" : "32px", ";row-gap:16px;min-width:0;margin-block-start:148px;", dist.mq.large, "{align-items:", isCompanySummaryStickyPosition ? "center" : "end", ";flex-direction:row;margin:0;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-grow:0;flex-shrink:0;", dist.mq.large, "{margin-block-end:", isCompanySummaryStickyPosition ? "0" : "-80px", ";}"),
                                            "data-test-id": "logo",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                name: props.company.name,
                                                src: props.company.imageUrl || (0,company/* companyDefaultImage */.tP)(props.company.recordType),
                                                size: isCompanySummaryStickyPosition ? "normal" : "extra-large",
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{width:96px !important;height:96px !important;}")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;row-gap:4px;width:100%;min-width:0;margin-block-end:0;", dist.mq.large, "{row-gap:2px;margin-block-end:", isCompanySummaryStickyPosition ? "0" : "20px", ";}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;column-gap:16px;"),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("dl", {
                                                            className: "corporate-number",
                                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;display:flex;line-height:1.25;color:", dist/* colors.textLight */.O9.textLight, ";font-size:13px;", dist.mq.large, "{color:", dist/* colors.textInvert */.O9.textInvert, ";font-size:14px;}"),
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("dt", {
                                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&::after{content:'：' / '';}"),
                                                                    children: "法人番号"
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("dd", {
                                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                                                                    className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                                                                    "data-test-id": "corporate-number",
                                                                    children: props.company.corporateNumber || "-"
                                                                })
                                                            ]
                                                        }),
                                                        ((0,company/* isResearchDone */.UX)(props.company) || (0,company/* isResearchUnvalued */.a5)(props.company)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tag */.Vp, {
                                                                inverted: true,
                                                                square: true,
                                                                color: "red",
                                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;"),
                                                                children: (0,company/* isIPO */.sH)(props.company) ? "IPO（".concat(props.company.researchStatus, "）") : props.company.researchStatus
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;color:", dist/* colors.text */.O9.text, ";font-size:24px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.5;letter-spacing:0.01em;overflow-wrap:break-word;transition:font-size 0.16s 0s linear;", dist.mq.large, "{color:", dist/* colors.textInvert */.O9.textInvert, ";font-size:", isCompanySummaryStickyPosition ? "28px" : "32px", ";line-height:1.25;", isCompanySummaryStickyPosition && "text-overflow: ellipsis; overflow: hidden; white-space: nowrap;", "}"),
                                                    "data-test-id": "name",
                                                    children: props.company.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.large, "{display:flex;justify-content:space-between;column-gap:16px;margin-block-end:", isCompanySummaryStickyPosition ? "0" : "8px", ";}"),
                                    children: [
                                        (0,lib_user/* isLatestEnterpriseOrTrial */.Fo)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:0;display:flex;column-gap:4px;"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusIcon, {
                                                    shortname: props.company.shortname,
                                                    statuses: props.statuses,
                                                    selectedStatus: props.selectedStatus,
                                                    setSelectedStatus: props.setSelectedStatus
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactPersonIcon, {
                                                    shortname: props.company.shortname,
                                                    selectedContactPerson: props.selectedContactPerson,
                                                    setSelectedContactPerson: props.setSelectedContactPerson,
                                                    users: props.users
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MemoIcon, {
                                                    companyMemo: props.companyMemo,
                                                    setIsStatusPanelVisible: props.setIsStatusPanelVisible
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:start;column-gap:8px;margin-block-start:12px;"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyFollowButton, {
                                                    shortname: props.company.shortname,
                                                    isEnterprise: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user),
                                                    showModal: props.showModal,
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)()
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubCommandMenu, {
                                                    company: props.company
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;max-width:1200px;margin:0 auto;min-height:200px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0 24px 10px;", dist.mq.large, "{margin-left:180px;padding:0px 20px 0px 32px;}font-size:14px;font-weight:400;line-height:150%;"),
                        children: (0,lib_user/* isGuest */.nJ)(user) && (0,company/* isResearchDone */.UX)(props.company) && !(0,company/* isExited */.EC)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "research-finished-message",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:16px;"),
                            children: [
                                "本企業は、スピーダ スタートアップ情報リサーチの",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "https://help.initial.inc/ja/articles/4570807",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        target: "_blank",
                                        decoration: "none",
                                        children: "スタートアップの定義"
                                    })
                                }),
                                "に則り、",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                    children: props.company.lastUpdatedAt
                                }),
                                "をもって調査を終了しました。"
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
                                    company: props.company
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryTags, {
                                    company: props.company
                                })
                            ]
                        })
                    }),
                    (!(0,lib_user/* isGuest */.nJ)(user) || (0,company/* isResearchContinue */.hD)(props.company) || (0,company/* isResearchUnvalued */.a5)(props.company) || (0,company/* isExited */.EC)(props.company)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                                dashed: true,
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:90%;margin:5px auto;", dist.mq.large, "{display:none;}")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryTable, {
                                company: props.company,
                                showModal: props.showModal
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var SummaryTags = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;"),
        children: props.company.tags.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
            children: props.company.tags.map(function(tag, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                    tag: tag
                }, i);
            })
        }) : (props.company.searchKeywords || []).length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;margin-bottom:15px;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-size:13px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-right:10px;"),
                    children: "検索キーワード："
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-wrap:wrap;"),
                    children: (props.company.searchKeywords || []).map(function(k, i) {
                        var isLast = (props.company.searchKeywords || []).length === i + 1;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            css: (0,emotion_react_browser_esm/* css */.iv)(CompanySummary_templateObject()),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    href: (0,url/* companySearchPath */.bB)(k),
                                    target: "_blank",
                                    css: (0,emotion_react_browser_esm/* css */.iv)(CompanySummary_templateObject1(), dist/* colors.text */.O9.text, dist/* colors.link */.O9.link),
                                    children: k
                                }),
                                isLast || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: ","
                                })
                            ]
                        }, k);
                    })
                })
            ]
        }) : null
    });
};
var SummaryTable = function(props) {
    var ref;
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;margin-bottom:18px;", dist.mq.large, "{flex-direction:row;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:12px 20px 5px;justify-content:space-between;flex-wrap:wrap;", dist.mq.large, "{padding-left:30px;padding-right:30px;width:50%;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:space-between;", dist.mq.large, "{justify-content:flex-start;}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                                    children: [
                                        "スピーダ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{display:none;}")
                                        }),
                                        "調達シリーズ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "https://help.initial.inc/ja/articles/4570885-initial%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA",
                                            target: "_blank",
                                            rel: "noopener",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.gray90 */.O9.gray90, ";"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("vertical-align:bottom;"),
                                                children: "スピーダが独自に定義する成長フェーズ"
                                            })
                                        })
                                    ]
                                }),
                                (0,company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeriesName, {
                                    series: props.company.latestInitialSeries
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:center;font-size:1.3rem;line-height:1.4;font-size:500;color:", dist/* colors.black30 */.O9.black30, ";", dist.mq.large, "{font-size:2rem;}"),
                                    children: "-"
                                }),
                                (0,company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateNote, {
                                    date: props.company.lastValuationDate,
                                    suffix: "時点"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;color:", dist/* colors.gray70 */.O9.gray70, ";"),
                                    children: "（調査終了）"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:space-between;", dist.mq.large, "{justify-content:flex-start;}"),
                        children: (0,company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                                    className: "post-money-valuation",
                                    children: [
                                        "調達後評価額",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{display:none;}")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabelAnnotation, {
                                            children: props.company.withoutDilutiveShares ? "（潜在株を含まない）" : "（潜在株を含む）"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmphasizedNumber, {
                                    unit: "百万円".concat(props.company.hasEstimatedRound ? "（推測）" : ""),
                                    testDataId: "post-money-valuation",
                                    children: props.company.valuation ? (0,number/* formatWithComma */.m$)((0,number/* thousandToMillion */.Km)(props.company.valuation)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyNumber, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateNote, {
                                    date: props.company.lastValuationDate,
                                    suffix: "時点"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                                    children: [
                                        "IPO時 時価総額",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{display:none;}")
                                        }),
                                        "(初値)"
                                    ]
                                }),
                                ((ref = props.company.ipoData) === null || ref === void 0 ? void 0 : ref.ipoMarketCap) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmphasizedNumber, {
                                    unit: "百万円",
                                    testDataId: "post-money-valuation",
                                    children: (0,number/* formatWithComma */.m$)(props.company.ipoData.ipoMarketCap)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-items:center;justify-content:space-between;", dist.mq.large, "{justify-content:flex-start;}"),
                        children: [
                            (0,company/* isPrivate */.hv)(props.company) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                                children: [
                                    "従業員数",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmployeesReportTypeLabel, {
                                        data: props.company
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabel, {
                                children: "IPO時従業員数"
                            }),
                            (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmphasizedNumber, {
                                        unit: "人",
                                        testDataId: "employees",
                                        className: "employees",
                                        children: props.company.employeesCount ? (0,number/* formatWithComma */.m$)(props.company.employeesCount) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyNumber, {})
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateNote, {
                                        date: props.company.employeesEventDate,
                                        suffix: suffixFromDateType(props.company.employeesDateType)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:120px;display:flex;align-items:center;justify-content:center;"),
                                className: "guest-employees",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: "/static/images/companies/guest/startup-blur-employee.png",
                                    alt: "従業員数"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                dashed: true,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:90%;margin:10px auto 5px;", dist.mq.large, "{display:none;}")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:12px 20px 5px;", dist.mq.large, "{padding-right:30px;flex:50%;padding-left:3.5rem;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SummaryLabel, {
                            children: [
                                "株主",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabelAnnotation, {
                                    children: (0,company/* isPrivate */.hv)(props.company) ? "（過去の株主を含む）" : "（IPO時）"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MajorShareholderNames, {
                            company: props.company,
                            showModal: props.showModal
                        })
                    ]
                })
            })
        ]
    });
};
var EmployeesReportTypeLabel = function(param) {
    var data = param.data;
    if (!data.employeesReportType || data.employeesReportType === "不明") {
        return null;
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLabelAnnotation, {
            children: "（".concat(data.employeesReportType, "）")
        });
    }
};
var EditLogoLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.white00 */.O9.white00, ";text-align:left;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            href: "/admin/companies/".concat(props.shortname, "/logo"),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.white00 */.O9.white00, ";"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    name: "gear",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:3px;vertical-align:bottom;")
                }),
                "ロゴを設定"
            ]
        })
    });
};
var SummaryLabel = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-bottom:12px;font-size:13px;"),
        className: props.className,
        children: props.children
    });
};
var SummaryLabelAnnotation = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "annotation",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";font-size:11px;", dist.mq.large, "{font-size:12px;}"),
        children: props.children
    });
};
var SeriesName = function(props) {
    var ref, ref1;
    if (!props.series) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptySeries, {});
    }
    var series = props.series === "シード" ? "シード" : (ref = props.series.match(/[A-G]/)) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase();
    var SeriesControl = function(props) {
        if (props.series === "シード") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:18px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";", dist.mq.large, "{margin:4px 0;font-size:24px;}"),
                children: props.series
            });
        } else {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:24px;", dist.mq.large, "{font-size:32px;}"),
                "data-test-id": "initial-series",
                children: props.series
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeriesControl, {
        series: series
    });
};
var EmphasizedNumber = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:24px;", dist.mq.large, "{font-size:32px;}"),
                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                "data-test-id": props.testDataId,
                children: props.children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:4px;font-size:13px;color:", dist/* colors.gray90 */.O9.gray90, ";"),
                children: props.unit
            })
        ]
    });
};
var EmptyNumber = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        "data-test-id": "empty-number",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:1rem;padding-right:1rem;font-size:32px;&::after{content:'−';}")
    });
};
var EmptySeries = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:40px;padding-left:1rem;padding-right:1rem;font-size:32px;&::after{content:'−';}")
    });
};
var DATE_TYPE_MAPPING = {
    時点日: "時点",
    確認日: "確認",
    提供日: "提供"
};
var suffixFromDateType = function(type) {
    return type && DATE_TYPE_MAPPING[type] ? DATE_TYPE_MAPPING[type] : "";
};
var DateNote = function(props) {
    if (!props.date) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:5px;color:", dist/* colors.textLight */.O9.textLight, ";white-space:nowrap;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;margin-right:2px;font-size:12px;", dist.mq.large, "{font-size:13px;}"),
                className: wovn/* IGNORED_BY_WOVN_CLASS_NAME */.Y,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                    children: props.date
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:normal;letter-spacing:normal;"),
                children: props.suffix
            })
        ]
    });
};
var EyecatchBg = function(props) {
    var TAG_EYECATCH_IMAGES = {
        software: "software.jpg",
        healthtech: "healthtech.jpg",
        ai: "ai.jpg",
        adtech: "adtech.jpg",
        hrtech: "hrtech.png",
        iot: "iot.jpg",
        content: "contents.jpg",
        copyright: "contents.jpg",
        fashion: "fashion.jpg",
        lifestyle: "fashion.jpg",
        fintech: "fintech.png",
        cleantech: "cleantech.jpg",
        semiconductor: "hardware.jpg",
        hardware: "hardware.jpg",
        "pharmaceutical-and-drug-discovery": "pharmaceutical.jpg",
        travel: "travel.jpg",
        "bio-chemicals": "biochemical.jpg",
        agritech: "agritech.jpg",
        "big-data": "bigdata.jpg",
        automotivetech: "automotivetech.jpg",
        architecture: "architecture.jpg",
        logistics: "logistics.jpg",
        space: "univers.jpg",
        edtech: "edtech.jpg",
        curation: "curation.jpg"
    };
    var DEFAULT_EYECATCH_IMAGE = "default.jpg";
    var eyecatchUrl = function(tags) {
        // NOTE: 紐づいているタグ内、先に来ているものが優先される
        var tag = tags.find(function(tag) {
            return Object.keys(TAG_EYECATCH_IMAGES).includes((tag === null || tag === void 0 ? void 0 : tag.slug) || "");
        });
        var tagSlug = tag && tag.slug ? tag.slug : null;
        return tagSlug ? TAG_EYECATCH_IMAGES[tagSlug] : DEFAULT_EYECATCH_IMAGE;
    };
    var background = "/static/images/companies/eyecatch/" + eyecatchUrl(props.tags);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyAndInvestorSummaryBg/* CompanyAndInvestorSummaryBg */.$, {
        backgroundImage: background,
        sticky: props.sticky,
        className: props.className,
        children: props.children
    });
};
var MajorShareholderNames = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    var names;
    if ((0,company/* isPrivate */.hv)(props.company)) {
        var ref, ref1;
        var majorInstitutionalShareholderNames = ((ref = props.company.institutionalShareholders) === null || ref === void 0 ? void 0 : ref.slice(0, 5).map(function(s) {
            return s.investor.name;
        })) || [];
        var majorAngelShareholderNames = ((ref1 = props.company.angelShareholders) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 5).map(function(s) {
            return s.investor.name;
        })) || [];
        names = majorInstitutionalShareholderNames.concat(majorAngelShareholderNames);
    } else {
        var ref2;
        names = ((ref2 = props.company.ipoShareholders) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 10).map(function(s) {
            return s.investor.name;
        })) || [];
    }
    if (names.length == 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";margin-top:10px;"),
            children: (0,company/* isPrivate */.hv)(props.company) ? "表示する情報がありません" : "データ未作成です"
        });
    }
    var handleClick = function(e) {
        e.preventDefault();
        if (!(0,lib_user/* isEnterpriseWithTrial */.xQ)(user)) {
            props.showModal();
        } else {
            router_default().push("".concat(props.company.path, "#shareholders"));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("line-height:1.5;font-size:14px;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:0.8em;"),
                "data-test-id": "shareholders",
                children: names.join(" / ")
            }),
            names.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                href: "#shareholders",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("white-space:nowrap;"),
                onClick: handleClick,
                children: "すべて見る"
            })
        ]
    });
};


/***/ }),

/***/ 14224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CompanyTabGroup; },
/* harmony export */   "q": function() { return /* binding */ companyTabList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44908);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18584);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73650);
/* harmony import */ var _lib_company__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10133);
/* harmony import */ var _common_Navbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3511);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96747);











var nonEnterpriseTabList = [
    "basic-info",
    "news",
    "shareholders",
    "directors",
    "performances",
    "partnerships", 
];
var privateTabList = [
    "basic-info",
    "finance-info",
    "news",
    "shareholders",
    "directors",
    "performances",
    "employees",
    "partnerships",
    "benchmarks",
    "others", 
];
var ipoTabList = [
    "basic-info",
    "finance-info",
    "ipo-data",
    "news",
    "directors",
    "performances",
    "employees",
    "partnerships",
    "benchmarks",
    "others", 
];
var companyTabList = lodash_uniq__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(privateTabList).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ipoTabList)));
var CompanyTabGroup = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .a)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var tabList = !(0,_lib_user__WEBPACK_IMPORTED_MODULE_4__/* .isEnterpriseWithTrial */ .xQ)(user) ? nonEnterpriseTabList : (0,_lib_company__WEBPACK_IMPORTED_MODULE_5__/* .isPrivate */ .hv)(props.data) ? privateTabList : ipoTabList;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref1, // ゲスト向けモバイルのタブバーのスクロール。Tab.Groupにrefをつけられないので、直下の子供を指定している。
        ref2;
        var activeTab = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".is-active");
        if (activeTab === null || activeTab === undefined) return;
        (ref2 = ref.current) === null || ref2 === void 0 ? void 0 : ref2.children[0].scroll({
            left: activeTab.offsetLeft - 32,
            behavior: "smooth"
        });
    }, [
        props.activeTab
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_common_Navbar__WEBPACK_IMPORTED_MODULE_6__/* .Navbar */ .w, {
        "data-test-id": "tab-group",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("padding:8px 0px;height:48px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{height:auto;padding:11px 0;position:sticky;top:160px;z-index:19;}"),
        isUnappliedSticky: (0,_lib_user__WEBPACK_IMPORTED_MODULE_4__/* .isEnterpriseWithTrial */ .xQ)(user),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            ref: ref,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("max-width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;white-space:nowrap;padding:0px 16px;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("display:flex;white-space:nowrap;gap:4px;"),
                        children: tabList.map(function(tab, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(CompanyNavigationTab, {
                                tab: tab,
                                data: props.data,
                                activeTab: props.activeTab
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
                        children: (0,_lib_user__WEBPACK_IMPORTED_MODULE_4__/* .isEnterpriseWithTrial */ .xQ)(user) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DownloadButton, {
                            onClick: props.showDownloadModal
                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, {
                            className: "follow-button-tooltip",
                            label: "有料契約限定の機能です",
                            place: "bottom",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DownloadButton, {
                                onClick: props.showTrialModal
                            })
                        })
                    })
                ]
            })
        })
    });
};
var CompanyNavigationTab = function(props) {
    var ref;
    var href = "/companies/".concat(props.data.shortname, "#").concat(props.tab);
    if (props.tab === "employees" && ((ref = props.data.employeesShift) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
        active: props.activeTab === props.tab,
        as: "a",
        href: href,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.untilMedium, "{font-size:14px;height:32px;}"),
        children: _lib_company__WEBPACK_IMPORTED_MODULE_5__/* .companyTabLabel */ .vg[props.tab]
    });
};
var DownloadButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
        className: "download-button",
        color: "black",
        outlined: true,
        size: "small",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("padding-left:12px !important;white-space:nowrap;"),
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__/* .IcomoonIcon */ .g, {
                name: "download",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("margin-right:7px;")
            }),
            "ダウンロード"
        ]
    });
};


/***/ }),

/***/ 31302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DoubleColumnContent; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var DoubleColumnContent = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("padding:15px 25px !important;display:flex;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{flex-direction:row;> dl{width:50%;&:last-of-type{padding-left:1rem;}}}"),
        children: props.children
    });
};


/***/ }),

/***/ 17239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useModal = function(props) {
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState((ref = props === null || props === void 0 ? void 0 : props.open) !== null && ref !== void 0 ? ref : false), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var show = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        return setIsOpen(true);
    }, [
        props.key
    ]);
    var hide = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        return setIsOpen(false);
    }, [
        props.key
    ]);
    return {
        isOpen: isOpen,
        show: show,
        hide: hide
    };
};


/***/ }),

/***/ 43585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getSmartroundUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79240);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);




var getSmartroundUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(ctx, corporateNumber) {
        var response, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (corporateNumber == null) {
                        return [
                            2,
                            null
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/smartround/").concat(corporateNumber))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.publicUrl
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_3__/* .printError */ .O)(e);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getSmartroundUrl(ctx, corporateNumber) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 76830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ checkSummaryStickyPosition; }
/* harmony export */ });
/* harmony import */ var _components_header_AppBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22991);

var FIXED_SUMMARY_HEIGHT = 96 + 24;
var SUMMARY_HEIGHT = 360;
var checkSummaryStickyPosition = function() {
    var appBarHeight = Number(_components_header_AppBar__WEBPACK_IMPORTED_MODULE_0__/* .APPBAR_HEIGHT.replace */ .sU.replace("px", ""));
    return appBarHeight + SUMMARY_HEIGHT - FIXED_SUMMARY_HEIGHT < window.scrollY;
};


/***/ })

}]);